<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        Asset Group
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="createDialog = true"
          >
            CREATE NEW ASSET GROUP
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataApi"
          item-key="id"
          class="font-weight-light"
          :loading="loadingGroup"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="assetGroupTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + dataApi.indexOf(item) + 1 }}
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ dateFormat(item) }}
          </template>
          <template #[`item.members`]="{ item }">
            <v-treeview
              dense
              :items="membersHandle(item.members)"
              :key="item.id"
            />
          </template>
          <template #[`item.metadata.no_booking_required`]="{ item }">
            <v-icon
              v-if="item.metadata.no_booking_required == 'true'"
              color="green"
            >
              mdi-check
            </v-icon>
          </template>
          <template #[`item.metadata.no_limit`]="{ item }">
            <v-icon
              v-if="item.metadata.no_limit == 'true'"
              color="green"
            >
              mdi-check
            </v-icon>
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              color="green"
              class="mr-2"
              @click="editItem(item)"
              v-if="!item.metadata.is_special"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              color="red"
              @click="declineItem(item)"
              v-if="!item.metadata.is_special"
            >
              mdi-delete
            </v-icon>
            <v-icon
              small
              color="blue"
              @click="editUser(item)"
              v-if="item.metadata.is_special"
            >
              mdi-account
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="createDialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-map-marker-plus
              </v-icon>Create Asset Group
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Group Name"
                    :rules="[(v) => !!v || 'Name is required']"
                    v-model="create.name"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => !!v || 'Description is required']"
                    v-model="create.description"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    v-model="create.asset_type"
                    :items="getAssetTypes"
                    :item-text="(item) => `${item.name}`"
                    :item-value="(item) => `${item.id}`"
                    label="Select Asset Type"
                    hide-details
                    outlined
                    :rules="[(v) => !!v || 'Select asset types is required']"
                    :disabled="selectedAssets.length > 0 || selectedVehicles.length > 0"
                  />
                </v-col>
                <!-- <v-col cols="12" sm="6" v-if="isAsset">
                  <v-select
                    v-model="create.assets"
                    :items="dataAssets"
                    :item-text="(item) => `${item.number}`"
                    :item-value="(item) => `${item.number}`"
                    :menu-props="{ maxHeight: '400' }"
                    label="Assign Asset"
                    outlined
                    multiple
                    :disabled="disableAsset"
                    hint="Select Asset for Group"
                    persistent-hint
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.number }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text text-caption"
                      >
                        (+{{ create.assets.length - 1 }} others)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col sm="6" cols="12" v-if="isAsset">
                  <div class="font-weight-medium">
                    Selected Asset
                  </div>
                  <v-text-field
                    v-if="!allSelected"
                    ref="search"
                    v-model="search"
                    hide-details
                    label="Search"
                    single-line
                  ></v-text-field>
                  <v-list>
                    <template v-for="item in categories">
                      <v-list-item
                        v-if="!selected.includes(item)"
                        :key="item"
                        @click="selected.push(item)"
                      >
                        <v-list-item-title v-text="item"></v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                  <v-divider v-if="!allSelected"></v-divider>
                  <v-col
                    v-for="(selection, i) in selections"
                    :key="selection"
                    class="shrink"
                  >
                    <v-chip
                      close
                      @click:close="selected.splice(i, 1)"
                    >
                      {{ selection }}
                    </v-chip>
                  </v-col>
                </v-col> -->
                <!-- <v-col cols="12" sm="6" v-if="isAsset">
                  <v-select
                    v-model="create.assets"
                    :items="dataAssets"
                    :item-text="(item) => `${item.number}`"
                    :item-value="(item) => `${item.number}`"
                    :menu-props="{ maxHeight: '400' }"
                    label="Assign Asset"
                    outlined
                    multiple
                    :disabled="disableAsset"
                    hint="Select Asset for Group"
                    persistent-hint
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.number }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text text-caption"
                      >
                        (+{{ create.assets.length - 1 }} others)
                      </span>
                    </template>
                  </v-select>
                </v-col> -->
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isAsset"
                >
                  <div class="font-weight-medium">
                    Available Asset
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAvailAsset"
                      v-model="searchAvailAsset"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in availAssets">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAssignedAssets(item)"
                        >
                          <v-list-item-title>
                            {{ item.number }}
                          </v-list-item-title>
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-right
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isAsset"
                >
                  <div class="font-weight-medium">
                    Assigned Asset
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAssignedAsset"
                      v-model="searchAssignedAsset"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in assignedAssets">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAvailAssets(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="item.number"
                          />
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isVehicleCreate"
                >
                  <div class="font-weight-medium mb-2">
                    Available Vehicle ({{ listAvailableForCreateFiltered.length }})
                  </div>
                  <v-card outlined>
                    <v-text-field
                      ref="searchAvailVehicle"
                      v-model="searchAvailVehicle"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAvailableForCreateFiltered">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAssignedVehicles(item)"
                        >
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-right
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isVehicleCreate"
                >
                  <div class="font-weight-medium mb-2">
                    Assigned Vehicle ({{ listAssignedForCreateFiltered.length }})
                  </div>
                  <v-card outlined>
                    <v-text-field
                      ref="searchAssignedVehicle"
                      v-model="searchAssignedVehicle"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAssignedForCreateFiltered">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAvailVehicles(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <!-- <v-col cols="12" sm="12" v-if="isVehicleCreate">
                  <v-select
                    v-model="create.vehicles"
                    :items="dataVehicles"
                    :item-text="
                      (item) => `${item.device_make} - ${item.device_name}`
                    "
                    :item-value="(item) => `${item.deviceid}`"
                    :menu-props="{ maxHeight: '400' }"
                    label="Assign Vehicle"
                    multiple
                    outlined
                    chips
                    hint="Select vehicles for group"
                    :disabled="disableVehicle"
                    persistent-hint
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.number }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption">
                        (+{{ create.vehicles.length - 1 }} others)
                      </span>
                    </template>
                  </v-select>
                </v-col> -->
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    label="No booking required"
                    color="green"
                    v-model="accessKey"
                    :disabled="noLimit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="isVictrack"
                >
                  <v-checkbox
                    label="No limit vehicle access"
                    color="green"
                    v-model="noLimit"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="close"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveCreate"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="green"
                class="mx-2"
              >
                mdi-pencil
              </v-icon>Update Asset Group
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="formEdit"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Group Name"
                    :rules="[(v) => !!v || 'Name is required']"
                    v-model="edit.name"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => !!v || 'Description is required']"
                    v-model="edit.description"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    v-model="edit.metadata.asset_type"
                    :items="getAssetTypes"
                    :item-text="(item) => `${item.name}`"
                    :item-value="(item) => `${item.id}`"
                    label="Select Asset Type"
                    hide-details
                    outlined
                    :disabled="selectedAssetsEdit.length > 0 || selectedVehiclesEdit.length > 0"
                  />
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isAsset"
                >
                  <div class="font-weight-medium">
                    Available Asset
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAvailEditAsset"
                      v-model="searchAvailEditAsset"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in availAssetsEdit">
                        <v-list-item
                          v-if="!selectedAssetsEdit.includes(item.id)"
                          :key="item.id"
                          @click="moveToAssignedAssetsEdit(item)"
                        >
                          <v-list-item-title>
                            {{ item.number }}
                          </v-list-item-title>
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-right
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isAsset"
                >
                  <div class="font-weight-medium">
                    Assigned Asset
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAssignedEditAsset"
                      v-model="searchAssignedEditAsset"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in assignedAssetsEdit">
                        <v-list-item
                          v-if="!selectedAssetsEdit.includes(item.id)"
                          :key="item.id"
                          @click="moveToAvailAssetsEdit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="item.number"
                          />
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isVehicle"
                >
                  <div class="font-weight-medium mb-2">
                    Available Vehicle ({{ listAvailableForEditFiltered.length }})
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAvailEditVehicle"
                      v-model="searchAvailEditVehicle"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAvailableForEditFiltered">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAssignedVehiclesEdit(item)"
                        >
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-right
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                  v-if="isVehicle"
                >
                  <div class="font-weight-medium mb-2">
                    Assigned Vehicle ({{ listAssignedForEditFiltered.length }})
                  </div>
                  <v-card>
                    <v-text-field
                      ref="searchAssignedEditVehicle"
                      v-model="searchAssignedEditVehicle"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAssignedForEditFiltered">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAvailVehiclesEdit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-checkbox
                    label="No booking required"
                    color="green"
                    v-model="edit.metadata.no_booking_required"
                    :disabled="edit.metadata.no_limit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="isVictrack"
                >
                  <v-checkbox
                    label="No limit vehicle access"
                    color="green"
                    v-model="edit.metadata.no_limit"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="closeEdit"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveEdit"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showError"
      persistent
      max-width="500"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title v-if="isVehicle || isVehicleCreate">
          <span>
            <v-icon>mdi-alert-circle</v-icon> Please select at least one vehicle!
          </span>
        </v-card-title>
        <v-card-title v-else>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Please select at least one asset!
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="showError = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="560"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this asset group?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this asset group permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="submitDeleteGroup()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="userDialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="green"
                class="mx-2"
              >
                mdi-account
              </v-icon>Update Special Group Users
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="py-0 px-0">
          <v-form
            ref="formUser"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  sm="6"
                  cols="12"
                >
                  <div class="font-weight-medium mb-2 d-flex justify-space-between">
                    <p class="mb-0">
                      Available Users
                    </p>
                    <v-icon
                      @click="moveAllToAssignedUsers"
                      style="cursor: pointer;"
                      title="Assign All Available Users"
                    >
                      mdi-arrow-right
                    </v-icon>
                  </div>
                  <v-card>
                    <v-text-field
                      v-model="searchAvailableUser"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAvailableUsers">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAssignedUsers(item)"
                        >
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-right
                            </v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col
                  sm="6"
                  cols="12"
                >
                  <div class="font-weight-medium mb-2 d-flex justify-space-between">
                    <v-icon
                      @click="moveAllToAvailableUsers"
                      style="cursor: pointer;"
                      title="Unassign All Assigned Users"
                    >
                      mdi-arrow-left
                    </v-icon>
                    <p class="mb-0">
                      Assigned Users
                    </p>
                  </div>
                  <v-card>
                    <v-text-field
                      v-model="searchAssignedUser"
                      hide-details
                      label="Search"
                      single-line
                      class="mx-3 my-1"
                    />
                    <v-list
                      class="overflow-y-auto"
                      max-height="300px"
                    >
                      <template v-for="item in listAssignedUsers">
                        <v-list-item
                          :key="item.id"
                          @click="moveToAvailableUsers(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>
                              mdi-arrow-left
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="closeUser"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveUser"
                block
                type="submit"
                color="success"
                :loading="loadingUpdateUser"
                :disabled="loadingUpdateUser"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import get from "lodash/get";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";

export default {
  data: () => ({
    token: "",
    clientid: "",
    reason: "",
    dataPool: [],
    createDialog: false,
    editDialog: false,
    userDialog: false,
    headers: [
      { text: "No", value: "no", sortable: false },
      {
        text: "Name",
        align: "left",
        value: "name",
      },
      { text: "Description", value: "description" },
      // { text: 'Metadata', value: 'metadata' },
      { text: "Members", value: "members", sortable: false },
      { text: "Not for Booking", value: "metadata.no_booking_required", sortable: false },
      { text: "Created At", value: "created_at" },
      { text: "Actions", value: "action", sortable: false },
    ],
    items: [
      {
        id: 1,
        name: "Assets (12) :",
        children: [{ id: 2, name: "Myke Card" }],
      },
      {
        id: 15,
        name: "Vehicles :",
        children: [
          { id: 16, name: "Toyota Yaris" },
          { id: 17, name: "Honda Supra" },
        ],
      },
    ],
    map: {
      name: "",
      longitude: "",
      latitude: "",
      style: "width: 200; height: 500px",
      center: {
        //   lat: -23.8511901,
        //   lng: 131.2038283,
      },
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      marker: {},
      position: {},
    },
    dataApi: [],
    showMap: false,
    dialog: false,
    dialog2: false,
    index: -1,
    userData: {},
    valid: true,
    validEdit: true,
    getAssetTypes: [],
    groupAssets: {
      data: [],
    },
    editgroupAssets: {
      data: [],
    },
    editparamGroupAssets: {
      data: [],
    },
    paramGroupAssets: {
      data: [],
    },
    create: {
      name: "",
      description: "",
      vehicles: [],
      assets: [],
      asset_type: "",
    },

    edit: {
      name: "",
      description: "",
      vehicles: [],
      assets: [],
      metadata: {
        asset_type: "",
        no_booking_required: false,
        no_limit: false,
      },
    },
    accessKey: false,
    noLimit: false,
    disableAsset: false,
    disableVehicle: false,
    isVehicle: false,
    isVehicleCreate: false,
    isAsset: false,
    loadingGroup: false,
    assets: [],
    vehicles: [],
    vehicleList: [],
    loadingUpdate: false,
    loadingUpdateUser: false,
    loader: null,
    selectedAssets: [],
    selectedVehicles: [],
    selectedAssetsEdit: [],
    selectedVehiclesEdit: [],
    searchData: "",
    searchDataTimeout: null,
    searchAvailAsset: "",
    searchAssignedAsset: "",
    searchAvailVehicle: "",
    searchAssignedVehicle: "",
    searchAvailEditAsset: "",
    searchAssignedEditAsset: "",
    searchAvailEditVehicle: "",
    searchAssignedEditVehicle: "",
    showError: false,
    overlay: false,
    deldialog: false,
    deleteTarget: null,
    assetGroupTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    searchAvailableUser: '',
    searchAssignedUser: '',
    users: [],
    filteredAvailableUsers: [],
    filteredAssignedUsers: [],
  }),
  created() {
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.overlay = true;
    this.getVehicleList();
  },
  mounted() {
    this.getTotal();
    this.getUser()
      .then(() => {
        this.getData();
      });
    this.getVehicles();
    this.getAssets();
    this.apiAssetTypes();
    if (this.isVictrack) {
      this.headers.splice(5, 0, { text: "No limit vehicle access", value: "metadata.no_limit", sortable: false });
    }
  },
  computed: {
    isVictrack() {
      return this.clientid == 'B34UUE8JJML5';
    },
    dataAssets() {
      return this.assets.filter((veh) => {
        const matchType = veh.type == this.create.asset_type;
        const isAssigned = this.selectedAssets.find((v) => v.id == veh.id);
        return matchType && isUndefined(isAssigned);
      });
    },
    dataEditAssets() {
      return this.assets.filter((veh) => {
        const matchType = veh.type == this.edit.metadata.asset_type;
        const isAssigned = this.selectedAssetsEdit.find((v) => v.id == veh.id);
        return matchType && isUndefined(isAssigned);
      });
    },
    dataVehicles() {
      return this.vehicles.filter((veh) => {
        const matchType = veh.type_id == this.create.asset_type;
        const isAssigned = this.selectedVehicles.find(
          (v) => v.id == veh.id
        );
        return matchType && isUndefined(isAssigned);
      });
    },
    dataEditVehicles() {
      return this.vehicles.filter((veh) => {
        const matchType = veh.type_id == this.edit.metadata.asset_type;
        const isAssigned = this.selectedVehiclesEdit.find(
          (v) => v.id == veh.id
        );
        return matchType && isUndefined(isAssigned);
      });
    },
    assignedAssets() {
      const search = this.searchAssignedAsset;
      if (!search) return this.selectedAssets;
      return this.selectedAssets.filter((item) => {
        const text = item.number;
        return text.indexOf(search) > -1;
      });
    },
    availAssets() {
      let search = !isUndefined(this.searchAvailAsset) ? this.searchAvailAsset.trim().toLowerCase() : "";
      return this.dataAssets.filter((item) => {
        const text = item.number.trim().toLowerCase();
        return text.indexOf(search) > -1;
      });
    },
    assignedAssetsEdit() {
      let search = this.searchAssignedEditAsset;
      if (!search) return this.selectedAssetsEdit;
      search = search.trim().toLowerCase()
      return this.selectedAssetsEdit.filter((item) => {
        const text = item.number;
        return text.trim().toLowerCase().indexOf(search) > -1;
      });
    },
    availAssetsEdit() {
      let search = !isUndefined(this.searchAvailEditAsset) ? this.searchAvailEditAsset.trim().toLowerCase() : "";
      return this.dataEditAssets.filter((item) => {
        const text = item.number;
        return text.trim().toLowerCase().indexOf(search) > -1;
      });
    },
    listAvailableForCreate() {
      return this.vehicleList
        .filter((v) => {
          const vehicle = this.vehicles.find((vehicle) => vehicle.id == v.id);
          const isMatchSelected = this.selectedVehicles.indexOf(v) === -1;
          const isMatchType = vehicle.type_id == this.create.asset_type;
          return isMatchSelected && isMatchType;
        });
    },
    listAvailableForCreateFiltered() {
      let search = !isUndefined(this.searchAvailVehicle) ? this.searchAvailVehicle.trim().toLowerCase() : "";
      return this.listAvailableForCreate
        .filter((v) => {
          return v.name.toLowerCase().indexOf(search) > -1;
        });
    },
    listAssignedForCreate() {
      return this.selectedVehicles;
    },
    listAssignedForCreateFiltered() {
      let search = this.searchAssignedVehicle;
      if (!search) return this.listAssignedForCreate;
      search = search.trim().toLowerCase()
      return this.listAssignedForCreate
        .filter((v) => v.name.toLowerCase().indexOf(search) > -1);
    },
    listAvailableForEdit() {
      return this.vehicleList
        .filter((v) => {
          const vehicle = this.vehicles.find((vehicle) => vehicle.id == v.id);
          const isMatchSelected = this.selectedVehicles.indexOf(v) === -1;
          const isMatchType = vehicle.type_id == this.edit.metadata.asset_type;
          return isMatchSelected && isMatchType && !this.selectedVehiclesEdit.find((vehicle) => vehicle.id == v.id);
        });
    },
    listAvailableForEditFiltered() {
      let search = !isUndefined(this.searchAvailEditVehicle) ? this.searchAvailEditVehicle.trim().toLowerCase() : "";
      return this.listAvailableForEdit
        .filter((v) => {
          return v.name.toLowerCase().indexOf(search) > -1;
        });
    },
    listAssignedForEdit() {
      return this.selectedVehiclesEdit;
    },
    listAssignedForEditFiltered() {
      let search = this.searchAssignedEditVehicle;
      if (!search) return this.listAssignedForEdit;
      search = search.trim().toLowerCase()
      return this.listAssignedForEdit
        .filter((v) => v.name.toLowerCase().indexOf(search) > -1);
    },
    availableUsers() {
      return this.users.filter((v) => {
        const isExists = this.assignedUsers.find((u) => u.id == v.id);
        return isUndefined(isExists);
      }).map((v) => {
        return {
          id: v.id,
          name: `${v.first_name} ${v.last_name}`, 
        };
      });
    },
    listAvailableUsers() {
      let search = this.searchAvailableUser;
      if (!search) return this.filteredAvailableUsers;
      search = search.trim().toLowerCase()
      return this.filteredAvailableUsers
        .filter((v) => v.name.toLowerCase().indexOf(search) > -1);
    },
    assignedUsers() {
      let assignedUsers = [];
      const specialGroup = this.dataApi.find((v) => v.metadata.is_special);
      if (specialGroup) {
        if (specialGroup.hasOwnProperty('users')) {
          if (specialGroup.users.length > 0) {
            assignedUsers = specialGroup.users.map((v) => {
              const user = this.users.find((u) => u.id == v.user_id);
              return {
                id: user.id,
                name: `${user.first_name} ${user.last_name}`, 
              };
            });
          }
        }
      }
      return assignedUsers;
    },
    listAssignedUsers() {
      let search = this.searchAssignedUser;
      if (!search) return this.filteredAssignedUsers;
      search = search.trim().toLowerCase()
      return this.filteredAssignedUsers
        .filter((v) => v.name.toLowerCase().indexOf(search) > -1);
    },
  },
  watch: {
    deldialog(show) {
      if (!show) {
        this.deleteTarget = null;
      }
    },
    "create.vehicles"(val) {
      if (val.length > 0) {
        val.forEach((dev) => {
          const test = {
            type: "device",
            deviceid: dev,
          };
          this.groupAssets.data.push(test);
        });
      }
    },
    "edit.vehicles"(val) {
      if (val.length > 0) {
        val.forEach((dev) => {
          if (!isUndefined(dev)) {
            this.disableAsset = true;
          } else {
            this.disableAsset = false;
          }
        });
      } else {
        this.disableAsset = false;
      }
    },
    "create.assets"(val) {
      if (val.length > 0) {
        val.forEach((asset) => {
          const test = {
            type: "asset",
            asset_id: asset,
          };

          this.groupAssets.data.push(test);
        });
      }
    },
    "edit.assets"(val) {
      if (val.length > 0) {
        val.forEach((asset) => {
          if (!isUndefined(asset)) {
            this.disableVehicle = true;
          } else {
            this.disableVehicle = false;
          }
        });
      } else {
        this.disableVehicle = false;
      }
    },
    "create.asset_type"(val) {
      if (isUndefined(val)) return;
      let filter = this.getAssetTypes.find((v) => v.id == val);
      if (!isUndefined(filter)) { 
        this.selectedAssets = [];
        this.selectedVehicles = [];
        if (filter.is_vehicle == "1") {
          this.isVehicleCreate = true;
          this.isAsset = false;
          this.accessKey = false;
        } else {
          this.isAsset = true;
          this.isVehicleCreate = false;
          this.accessKey = true;
        }
      }
    },
    "edit.metadata.asset_type"(val) {
      if (isUndefined(val)) return;
      let filter = this.getAssetTypes.find((v) => v.id == val);
      if (!isUndefined(filter)) {
        if (filter.is_vehicle == "1") {
          this.selectedVehiclesEdit = this.selectedVehiclesEdit.filter((v) => {
            const vehicle = this.vehicles.find((item) => item.id == v.id);
            return vehicle.type_id == val;
          });
          this.isVehicle = true;
          this.isAsset = false;
        } else {
        this.selectedAssetsEdit = this.selectedAssetsEdit.filter((v) => {
          const asset = this.dataAssets.find((item) => item.id == v.id);
          return asset.type == val;
        });
          this.isAsset = true;
          this.isVehicle = false;
        }
      }
    },
    'edit.metadata.no_limit'(val) {
      if (val) {
        this.edit.metadata.no_booking_required = true;
      } else {
        this.edit.metadata.no_booking_required = false;
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    selected() {
      this.search = "";
    },
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 2e3);
    },
    searchData() {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getTotal();
        this.getData();
      }, 1e3)
    }
  },
  methods: {
    moveToAssignedUsers(user) {
      const index = this.filteredAssignedUsers.findIndex((v) => v.id == user.id);
      if (index === -1) {
        this.filteredAssignedUsers.push(user);
      }
      const index2 = this.filteredAvailableUsers.findIndex((v) => v.id == user.id);
      if (index2 !== -1) {
        this.filteredAvailableUsers.splice(index2, 1);
      }
    },
    moveToAvailableUsers(user) {
      const index = this.filteredAvailableUsers.findIndex((v) => v.id == user.id);
      if (index === -1) {
        this.filteredAvailableUsers.push(user);
      }
      const index2 = this.filteredAssignedUsers.findIndex((v) => v.id == user.id);
      if (index2 !== -1) {
        this.filteredAssignedUsers.splice(index2, 1);
      }
    },
    moveAllToAssignedUsers() {
      this.filteredAssignedUsers = this.filteredAssignedUsers.concat(this.listAvailableUsers);
      this.filteredAvailableUsers = [];
    },
    moveAllToAvailableUsers() {
      this.filteredAvailableUsers = this.filteredAvailableUsers.concat(this.listAssignedUsers);
      this.filteredAssignedUsers = [];
    },
    arraysAreEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }

      const sortedArr1 = arr1.slice().sort();
      const sortedArr2 = arr2.slice().sort();

      for (let i = 0; i < sortedArr1.length; i++) {
        if (parseInt(sortedArr1[i]) !== parseInt(sortedArr2[i])) {
          return false;
        }
      }

      return true;
    },
    isGroupVehicle(group) {
      const assetType = group.metadata ? group.metadata.asset_type : null
      if (assetType === null) return false;
      const match = this.getAssetTypes.find((v) => v.id == assetType);
      if (!match) return false;
      return match.is_vehicle === '1'
    },
    saveCreate() {
      if (this.$refs.form.validate()) {
        if (this.isAsset) {
          this.selectedAssets.forEach((asset) => {
            const test = {
              type: "asset",
              asset_id: asset.id,
            };
            const isExists = this.groupAssets.data.find(
              (g) => g.type == test.type && g.asset_id == test.asset_id
            );
            if (isUndefined(isExists)) this.groupAssets.data.push(test);
          });
        } else if (this.isVehicleCreate) {
          this.selectedVehicles.forEach((dev) => {
            const test = {
              type: "device",
              id: dev.id,
            };
            const isExists = this.groupAssets.data.find(
              (g) => g.type == test.type && g.id == test.id
            );
            if (isUndefined(isExists)) this.groupAssets.data.push(test);
          });
        } else if (this.isVehicle) {
          this.selectedVehicles.forEach((dev) => {
            const test = {
              type: "device",
              id: dev.id,
            };
            const isExists = this.groupAssets.data.find(
              (g) => g.type == test.type && g.id == test.id
            );
            if (isUndefined(isExists)) this.groupAssets.data.push(test);
          });
        }

        this.paramGroupAssets.data = this.groupAssets.data;

        const metadata = {
          no_booking_required: this.accessKey,
          asset_type: this.create.asset_type,
          no_limit: this.noLimit,
        };

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        if (this.isAsset && isEmpty(this.selectedAssets)) {
          this.showError = true;
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
        } else if (
          (this.isVehicle || this.isVehicleCreate) &&
          isEmpty(this.selectedVehicles)
        ) {
          this.showError = true;
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
        } else {
          this.$store.dispatch('API_CALL', {
              $method: 'create_asset_group',
              $postData: {
                clientid: this.clientid,
                name: this.create.name,
                description: this.create.description,
                assets: this.paramGroupAssets,
                metadata,
              },
            })
            .then((response) => {
              if (response.data.code == 200) {
                this.loadingUpdate = false;
                this.loader = this.loadingUpdate;
                this.$swal({
                  icon: "success",
                  title: response.data.data.message,
                });
                this.getTotal();
                this.getData();
                this.close();
              } else {
                this.$swal({
                  icon: "error",
                  title: response.data.data.message,
                });
              }
            });
        }
      }
    },
    close() {
      this.createDialog = false;
      // this.editDialog = false;
      this.groupAssets.data = [];
      this.$refs.form.reset();
      this.disableVehicle = false;
      this.disableAsset = false;
      this.isVehicleCreate = false;
      this.isAsset = false;
      this.isVehicle = false;
      this.selectedAssets = [];
      this.selectedVehicles = [];
      this.paramGroupAssets.data = [];
      this.editparamGroupAssets.data = [];
      this.editgroupAssets.data = [];
      // this.isVehicle = false
      // this.isAsset = false

      // this.$refs.formEdit.reset();
    },
    closeEdit() {
      this.disableVehicle = false;
      this.disableAsset = false;
      this.editDialog = false;
      this.groupAssets.data = [];
      this.disableVehicle = false;
      this.disableAsset = false;
      this.isVehicleCreate = false;
      this.isAsset = false;
      this.isVehicle = false;
      this.selectedAssets = [];
      this.selectedVehicles = [];
      this.paramGroupAssets.data = [];
      this.editparamGroupAssets.data = [];
      this.editgroupAssets.data = [];
    },
    editItem(item) {
      this.searchAvailEditAsset = "";
      this.searchAssignedEditAsset = "";
      this.searchAvailEditVehicle = "";
      this.searchAssignedEditVehicle = "";
      const isVehicle = this.isGroupVehicle(item)
      this.selectedAssetsEdit = [];
      this.selectedVehiclesEdit = [];
      const currentItem = cloneDeep(item);
      let dataAssetDevice = [];
      let dataAsset = [];
      currentItem.members.forEach((element) => {
        if (element.obj_type === "device") {
          const vehicle = this.vehicleList.find(
            (v) => v.id == element.obj_id
          );
          this.selectedVehiclesEdit.push(vehicle);
          dataAssetDevice.push(element.detail.id);
        } else {
          const asset = this.assets.find((a) => a.id == element.obj_id);
          this.selectedAssetsEdit.push(asset);
          dataAsset.push(element.detail.id);
        }
      });
      if (isVehicle) {
        dataAsset = [];
        this.isVehicle = true;
      }
      if (!isVehicle) {
        dataAssetDevice = [];
        this.isAsset = true;
      }

      this.edit.vehicles = dataAssetDevice;
      this.edit.assets = dataAsset;
      this.editDialog = true;
      this.edit.name = currentItem.name;
      this.edit.description = currentItem.description;
      this.edit.id = currentItem.id;

      const metadata = get(currentItem, "metadata", {});
      this.edit.metadata = isNull(metadata) ? {} : metadata;
      this.edit.metadata.asset_type = get(
        currentItem.metadata,
        "asset_type",
        false
      );
      const no_booking_required = get(
        currentItem.metadata,
        "no_booking_required",
        false
      );
      if (no_booking_required == "true") {
        this.edit.metadata.no_booking_required = true;
      } else {
        this.edit.metadata.no_booking_required = false;
      }
      const no_limit = get(currentItem.metadata, "no_limit", false);
      if (no_limit == "true") {
        this.edit.metadata.no_limit = true;
      } else {
        this.edit.metadata.no_limit = false;
      }
    },
    editUser() {
      this.userDialog = true;
      this.searchAssignedUser = "";
      this.searchAvailableUser = "";
      this.filteredAvailableUsers = Object.assign([], this.availableUsers);
      this.filteredAssignedUsers = Object.assign([], this.assignedUsers);
    },
    saveUser() {
      this.loadingUpdateUser = true;
      this.loader = this.loadingUpdateUser;
      const users = this.filteredAssignedUsers.map((v) => ({
        id: v.id,
        is_special: true
      }));
      this.filteredAvailableUsers.forEach((v) => {
        users.push({
          id: v.id,
          is_special: false
        });
      });
      this.$store.dispatch('API_CALL', {
        $method: 'set_special_address_member',
        $postData: {
          users,
          group_id: this.dataApi.find((v) => v.metadata.is_special).id,
        },
      })
      .then((response) => {
        if (response.data.code == 200) {
          this.loadingUpdateUser = false;
          this.loader = this.loadingUpdateUser;
          this.$swal({
            icon: "success",
            title: response.data.data.message,
          });
          this.getTotal();
          this.getData();
          this.closeUser();
        } else {
          this.$swal({
            icon: "error",
            title: response.data.data.message,
          });
        }
      });
    },
    closeUser() {
      this.userDialog = false;
    },
    saveEdit() {
      if (this.$refs.formEdit.validate()) {
        if (this.isAsset) {
          this.selectedAssetsEdit.forEach((asset) => {
            const test = {
              type: "asset",
              asset_id: asset.id,
            };

            const isExists = this.editgroupAssets.data.find(
              (g) => g.type == test.type && g.asset_id == test.asset_id
            );
            if (isUndefined(isExists)) this.editgroupAssets.data.push(test);
          });
        }

        if (this.isVehicle) {
          this.selectedVehiclesEdit.forEach((dev) => {
            const test = {
              type: "device",
              id: dev.id,
            };

            const isExists = this.editgroupAssets.data.find(
              (g) => g.type == test.type && g.id == test.id
            );
            if (isUndefined(isExists)) this.editgroupAssets.data.push(test);
          });
        }

        this.editparamGroupAssets.data = this.editgroupAssets.data;

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        this.$store.dispatch('API_CALL', {
            $method: 'update_asset_group',
            $postData: {
              group_id: this.edit.id,
              clientid: this.clientid,
              name: this.edit.name,
              description: this.edit.description,
              assets: this.editparamGroupAssets,
              metadata: this.edit.metadata,
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.$swal({
                icon: "success",
                title: response.data.data.message,
              });
              this.getTotal();
              this.getData();
              this.closeEdit();
            } else {
              this.$swal({
                icon: "error",
                title: response.data.data.message,
              });
            }
          });
      }
    },
    declineItem(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    submitDeleteGroup(){
      this.token = this.$store.state.token;
      this.$store.dispatch('API_CALL', {
          $method: 'delete_asset_group',
          $postData: {
            id: this.deleteTarget.id
          },
        })
        .then((response) => {
          this.deldialog = false;
          if(response.data.code == 200) {
            this.$swal({
              icon: "success",
              title: response.data.data.message,
            });
            Promise.all([
              this.getTotal(),
              this.getData(),
            ]).then(() => {
              // Total data ada, tapi di page ini kosong
              if (this.assetGroupTotal > 0 && this.dataApi.length === 0) {
                // reset page ke page 1
                this.paginationOptions.page = 1
                // load ulang data
                this.getTotal();
                this.getData();
              }
            })
          } else {
            this.$swal({
              icon: "error",
              title: response.data.data.message,
            });
          }
        });

    },
    getTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      return this.$store.dispatch('API_CALL', {
        $method: 'get_asset_group_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData
        },
      }).then((response) => {
        this.assetGroupTotal = parseInt(response.data.data.total);
      })
    },
    getUser() {
      return this.$store.dispatch('API_CALL', {
        $method: 'get_all',
        $postData: {
          clientid: this.clientid,
        },
      })
        .then((response) => {
          this.users = response.data.data;
        });
    },
    getData() {
      this.loadingGroup = true;
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'name';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_asset_groups',
          $postData: {
            clientid: this.$store.state.clientid,
            limit: itemsPerPage,
            offset,
            sort_by,
            sort_dir,
            query: this.searchData
          },
        })
        .then((response) => {
          this.loadingGroup = false;
          this.dataApi = response.data.data;
        });
    },
    getVehicles() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.vehicles = response.data.data;
        });
    },
    getVehicleList() {
      const { clientid } = this.$store.state;
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicle_list',
          $postData: {
            clientid,
          },
        })
        .then((response) => {
          this.vehicleList = response.data.data;
        });
    },
    getAssets() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_assets',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.assets = response.data.data;
        });
    },
    apiAssetTypes() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.getAssetTypes = response.data.data;
        });
    },
    dateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("created_at")) {
        date = moment(item.created_at).format("D MMM YYYY HH:mm");
      }
      return date;
    },
    membersHandle(item) {
      let data = [];
      item.forEach((member) => {
        if (member.hasOwnProperty("detail")) {
          const isDataMatch = data.find((d) => d.name == member.type);
          if (!isDataMatch) {
            data.push({
              name: member.type,
              children: [],
            });
          }
          const findIndex = data.findIndex((d) => d.name == member.type);
          if (member.obj_type === 'device') {
            data[findIndex]["children"].push({
              id: member.detail.id,
              // name: `${member.detail.device_make} - ${member.detail.device_name}`,
              name: member.detail.device_name,
            });
          } else {
            data[findIndex]["children"].push({
              id: member.detail.id,
              name: member.detail.number,
            });
          }
        }
      });

      data.map((v) => {
        return (v.name = `${v.name} (${item.length})`);
      });

      return data;
    },
    moveToAssignedAssets(item) {
      this.selectedAssets.push(item);
    },
    moveToAvailAssets(item) {
      const index = this.selectedAssets.indexOf(item)
      if (index > -1) {
        this.selectedAssets.splice(index, 1);
      }
    },
    moveToAssignedVehicles(item) {
      this.selectedVehicles.push(item);
    },
    moveToAvailVehicles(item) {
      const index = this.selectedVehicles.indexOf(item)
      if (index > -1) {
        this.selectedVehicles.splice(index, 1);
      }
    },
    moveToAssignedAssetsEdit(item) {
      this.selectedAssetsEdit.push(item);
    },
    moveToAvailAssetsEdit(item) {
      const index = this.selectedAssetsEdit.indexOf(item)
      if (index > -1) {
        this.selectedAssetsEdit.splice(index, 1);
      }
    },
    moveToAssignedVehiclesEdit(item) {
      this.selectedVehiclesEdit.push(item);
    },
    moveToAvailVehiclesEdit(item) {
      const index = this.selectedVehiclesEdit.indexOf(item)
      if (index > -1) {
        this.selectedVehiclesEdit.splice(index, 1);
      }
    },
    getDeviceDetail(item) {
      let id = get(item, "detail.id", "");
      if (id == "") {
        id = get(item, "id", "");
        if (id == "") {
          return get(item, "obj_id", "");
        }
      }
      const vehicle = this.vehicles.find((v) => v.id == id);
      const deviceMake = get(vehicle, "device_make", "");
      const deviceName = get(vehicle, "device_name", "");

      return `${deviceMake} - ${deviceName}`;
    },
    updatePaging(options) {
      this.getTotal();
      this.paginationOptions = options;
      this.getData();
    },
  },
};
</script>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-content {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  text-align: center;
  color: #61534e;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-cancel {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-confirm {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
</style>
